namespace TabAurous.Membership {

    @Serenity.Decorators.registerClass()
    export class LoginPanel extends Serenity.PropertyPanel<LoginRequest, any> {

        protected getFormKey() { return LoginForm.formKey; }

        constructor(container: JQuery) {
            super(container);
            $('#slider')['vegas']({
                delay: 10000,
                cover: true,
                overlay: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAQMAAABIeJ9nAAAAA3NCSVQICAjb4U" +
                    "/gAAAABlBMVEX///8AAABVwtN+AAAAAnRSTlMA/1uRIrUAAAAJcEhZcwAAAsQAAALEAVuRnQsAAAAWdEVYdENyZWF0" +
                    "aW9uIFRpbWUAMDQvMTMvMTGrW0T6AAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M1cbXjNgAAAAxJREFUCJljaGBgAAABhACBrONIPgAAAABJRU5ErkJggg==",
                slides: [
                    { src: Q.resolveUrl("~/css/login-bg.jpg"), transition: 'zoomOut' },
                    { src: Q.resolveUrl("~/css/login-bg-2.jpg"), transition: 'fade' },
                    { src: Q.resolveUrl("~/css/login-bg-3.jpg"), transition: 'zoomOut' },
                    { src: Q.resolveUrl("~/css/login-bg-4.jpg"), transition: 'fade' }
                ]
            });

            this.byId('LoginButton').click(e => {
                e.preventDefault();
                if (!this.validateForm()) {
                    return;
                }
                var request = this.getSaveEntity();
                var RootUrl = $('base').attr('href');
                console.log(Q.resolveUrl('~/Account/Login'));
                Q.serviceCall({
                    url: Q.resolveUrl('~/Account/Login'),
                    request: request,
                    onSuccess: response => {
                        this.redirectToReturnUrl();
                    },
                    onError: (response: Serenity.ServiceResponse) => {
                        if (response != null && response.Error != null && !Q.isEmptyOrNull(response.Error.Message)) {
                            Swal.fire({
                                icon: 'error',
                                title: 'Login Failed',
                                text: response.Error.Message,
                                showConfirmButton: true
                            })
                            $('#Password').focus();
                            return;
                        }
                        Q.ErrorHandling.showServiceError(response.Error);
                    }

                });
            });


        }

        protected redirectToReturnUrl() {
            var q = Q.parseQueryString();
            var returnUrl = q['returnUrl'] || q['ReturnUrl'];
            if (returnUrl) {
                var hash = window.location.hash;
                if (hash != null && hash != '#')
                    returnUrl += hash;

                console.debug(returnUrl);
                window.location.href = returnUrl;
            }
            else {

                console.debug(returnUrl);
                let t = Q.resolveUrl('~/');
                window.location.href = Q.resolveUrl('~/');
            }
        }

        protected getTemplate() {
            return `
                    <h3 class="text-white text-center mb-4">Sign In</h3>
                    <form id="~_Form" class="form-dark" method="post">
                        <div id="~_PropertyGrid"> </div>
                        <button class="btn btn-primary btn-block my-4" id="~_LoginButton" type="submit">${Q.text("Forms.Membership.Login.SignInButton")}</button>
                    </form>
            </script>`
        }
    }
}